import { render, staticRenderFns } from "./BeneficiariesIndex.vue?vue&type=template&id=bbcc1562"
import script from "./BeneficiariesIndex.vue?vue&type=script&lang=js"
export * from "./BeneficiariesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports